<template>
  <div class="Header">
    <div class="container Header__wrapper">
      <router-link to="/">
        <img class="Header__logo" :src="logoUrl" />
      </router-link>
      <transition name="fade">
        <div class="Header__main-menu" :class="{activeMenu : isMenuOpen}">
          <div
            class="Header__main-menu--link"
            @click="activeLink = link.id"
            @mouseenter="activeLink = link.id"
            @mouseleave="activeLink = ''"
            v-for="link in links"
            :key="link.id"
          >
            <a :href="link.url">{{link.text}}</a>
            <i v-if="link.children.length" class="fas fa-caret-down icon"></i>
            <transition name="menu">
              <div
                v-if="link.children.length && activeLink == link.id"
                class="Header__main-menu--children"
                v-on-clickaway="closeMenu"
              >
                <div v-for="child in link.children" :key="child.id">
                  <a :href="child.url">{{child.text}}</a>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </transition>

      <div class="Header__buttons">
        <button
          :key="'login'"
          v-if="!user.loggedIn"
          class="button button__login ml-3"
          @click="openLoginModal"
        >
          <i class="fa fa-user icon mr-3"></i>
          GİRİŞ YAP
        </button>
        <button
          tag="button"
          v-if="user.loggedIn"
          class="button button__login"
          @click="isProfileMenuOpen = !isProfileMenuOpen"
        >
          <i class="fa fa-user mr-3 icon"></i>
          {{user.data.fullName}}
        </button>
        <router-link tag="button" class="button button__donate ml-3" to="/">
          BAĞIŞ SEPETİ
          <span>{{totalBasketItems}}</span>
        </router-link>
      </div>

      <!-- FOR MOBILE -->
      <div class="Header__mobile">
        <button class="Header__mobile--login" @click="openLoginModal">
          <i class="fa fa-user icon"></i>
        </button>
        <div class="Header__hamburger" :class="{active: isMenuOpen}" @click="openMenu"></div>
      </div>
      <!-- END FOR MOBILE -->

      <transition name="fade">
        <div class="Header__menu" v-if="isProfileMenuOpen" v-on-clickaway="closeProfileDropdown">
          <a
            v-if="isDashboardPermission()"
            class="Header__menu--link"
            href="https://bagis.ismailagadernegi.org.tr/panel"
          >Panel</a>
          <router-link class="Header__menu--link" to="/bagislarim">Bağışlarım</router-link>
          <router-link class="Header__menu--link" to="/ayarlar">Ayarlar</router-link>
          <a class="Header__menu--link" @click="handleLogout">Çıkış</a>
        </div>
      </transition>
    </div>
    <!-- FOR MOBILE -->
    <button tag="button" class="button button__donate button__mobile--donate" @click="openNavbar">
      Bağış Sepeti
      <span>{{totalBasketItems}}</span>
    </button>
    <!-- END FOR MOBILE -->
  </div>
</template>


<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { mixin as clickaway } from 'vue-clickaway'

export default {
  mixins: [clickaway],
  data() {
    return {
      links: [],
      isOpen: false,
      activeLink: '',
      isMenuOpen: false,
      isProfileMenuOpen: false,
      isHambuergerOpen: false,
      logoUrl: '',
      // eslint-disable-next-line
      logo_1x: require("@/assets/img/logo_dark-1x.jpg"),
      // eslint-disable-next-line
      logo_2x: require("@/assets/img/logo_dark-2x.png")
    }
  },
  computed: {
    ...mapGetters(['totalBasketItems', 'totalPrice', 'toggleLoginModal'])
  },
  methods: {
    closeMenu() {
      this.activeLink = ''
    },
    openMenu() {
      this.activeLink = ''
      this.isMenuOpen = !this.isMenuOpen
    },
    ...mapMutations(['logout']),
    ...mapActions(['fetchBasketFromLocal', 'fetchProducts']),
    closeProfileDropdown() {
      this.isProfileMenuOpen = !this.isProfileMenuOpen
    },
    isRetina() {
      return (
        window.matchMedia
        && window.matchMedia(
          'only screen and (min--moz-device-pixel-ratio: 2), '
            + 'only screen and (-o-min-device-pixel-ratio: 2/1), '
            + 'only screen and (-webkit-min-device-pixel-ratio: 2), '
            + 'only screen and (min-device-pixel-ratio: 2)'
        ).matches
      )
    },
    openNavbar() {
      this.isHambuergerOpen = !this.isHambuergerOpen
      this.$root.$emit('open-nav', this.isHambuergerOpen)
    },
    openLoginModal() {
      if (this.user.loggedIn) {
        this.isProfileMenuOpen = !this.isProfileMenuOpen
      } else {
        this.$modal.show('login-modal')
      }
    },
    handleLogout() {
      this.logout()
      this.isProfileMenuOpen = false
      this.$router.push('/')
    },
    me() {
      this.$http('user/me')
    }
  },
  watch: {
    $route() {
      this.isProfileMenuOpen = false
    }
  },
  created() {
    this.$http.get('menu/ust').then((res) => {
      this.links = res.data.data.menu_objects
    })

    this.logoUrl = this.isRetina() ? this.logo_2x : this.logo_1x
    this.fetchBasketFromLocal()
  }
}
</script>


<style scoped>
.fade-enter-active,
.fade-leave-active,
 .menu-leave-active,
  .menu-enter-active{
  transition: all 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-20px) scale(0.9);
}

.menu-enter,
.menu-leave-to {
  opacity: 0;
  transform: translateY(-20px) translateX(-50%) scale(0.9);
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
